import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

/**
 * Escapes a value for CSV export and forces Excel to treat it as text.
 *
 * This function:
 * - Converts the value to a string
 * - Escapes double quotes by doubling them
 * - Wraps the value in ="..." to prevent Excel from:
 *
 * @param value - The value to escape (string, number, or undefined)
 * @returns A CSV-safe string that Excel will treat as text
 */
function escapeCsvValue(value: string | number | undefined): string {
  const str = String(value ?? '');
  const escaped = str.replace(/"/g, '""');
  return `="${escaped}"`;
}

@Injectable({ providedIn: 'root' })
export class ExcelUtilClass {
  downloadFile(data: Blob, fileName: string) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  extractFileName(res: HttpResponse<Blob>) {
    const contentDisposition = res.headers.get('content-disposition');
    let fileName = '';
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDisposition || '');
    if (matches !== null && matches !== undefined && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }
    return fileName || '';
  }

  generateCsvFromData(headers: string[], data: Partial<Record<string, string | number>>[], fileName: string) {
    const csvContent = [
      headers.length ? headers.map(escapeCsvValue).join(',') : '',
      data.map((row) => headers.map((header) => escapeCsvValue(row[header])).join(',')).join('\n'),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = fileName;
    anchor.click();

    URL.revokeObjectURL(url);
  }
}
